export default [
  {
    path: '/motoristas',
    name: 'fleetUser',
    component: () => import(/* webpackChunkName: "fleet" */ './List.vue'),
    meta: { auth: true }
  },
  {
    path: '/motoristas/novo',
    name: 'fleetUser/novo',
    component: () => import(/* webpackChunkName: "fleet" */ './Add.vue'),
    meta: { auth: true }
  },
  {
    path: '/motoristas/:id',
    name: 'fleetUser/editar',
    component: () => import(/* webpackChunkName: "fleet" */ './Edit.vue'),
    meta: { auth: true }
  },
  {
    path: '/motoristas/:id/remover',
    name: 'fleetUser/remover',
    component: () => import(/* webpackChunkName: "fleet" */ './Remove.vue'),
    meta: { auth: true }
  }
]
